import {UI} from "../../stem-core/ui/UIBase";
import {StyleSheet, styleRule, registerStyle} from "../../stem-core/ui/Style";
import {Theme} from "../../stem-core/ui/style/Theme";

export class DashboardLineSeparatorStyle extends StyleSheet {
    @styleRule
    container = {
        margin: "8px 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 16,
        fontWeight: 700,
    };

    @styleRule
    text = {
        padding: "0 8px",
        color: this.themeProps.DIVIDER_TEXT_COLOR,
    };

    @styleRule
    line = {
        minHeight: 1,
        width: "100%",
        flex: 1,
    };
}

@registerStyle(DashboardLineSeparatorStyle)
export class DashboardLineSeparator extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            lineColor: Theme.props.DIVIDER_LINE_COLOR,
            text: null,
        }
    }

    render() {
        const {styleSheet} = this;
        const {text, lineColor} = this.options;
        return [
            <div className={styleSheet.line} style={{background: lineColor}}/>,
            text && <div className={styleSheet.text}>{text}</div>,
            <div className={styleSheet.line} style={{background: lineColor}}/>,
        ]
    }
}
